// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-content[data-v-11410d58] {\r\n  width: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
